export default {
    LINE_THICKNESS_DEFAULT: 2,
    LINE_THICKNESS_SELECTED: 4,
    NODE_ROUND_RADIUS: 10,
    IMG_PADDING: 8
};
